import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import Select from "react-select";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import Loader from "../Chargers/Loader";
import { Link } from "react-router-dom";
import request from "../../Apis/request";

function Assign() {
  let params = useParams();
  let stationID = params?.qid;

  const [selectedEmi, setSelectedEmi] = useState([]);
  const [chargers, setChargers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ChargerData, setChargerData] = useState([]);
  const [filteredChargerData, setFilteredChargerData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [userStatuses, setUserStatuses] = useState({});
  const [statusListing, setStatusListing] = useState([]);
  let navigate = useNavigate();

  const handleStatusType = async (event, userId) => {
    const status = event.target.value;
  
    // Update local state
    setUserStatuses(prevStatuses => ({
      ...prevStatuses,
      [userId]: status
    }));
  
    const url = `${BaseURL}/chargers/changestatus/${userId}`;
  
    // Create JSON payload
    const statusData = { status };
  
    try {
      // Send status as JSON instead of FormData
      const response = await axios.put(url, statusData, {
        headers: {
          "Content-Type": "application/json", // Send as JSON
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message, 
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        console.log("Failed to update status", response.data);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const fetchChargerrs = async () => {
    setLoading(true);

    // Set the base API endpoint
    let apiEndpoint = `${BaseURL}/chargers`;

    // Conditionally add station_id to the endpoint if stationnID exists
    if (stationID) {
        apiEndpoint += `?station_id=${stationID}`;
    }

    try {
        const response = await axios.get(apiEndpoint, {
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${uniqueToken}`,
            },
        });

        setChargerData(response.data.data.data || []);
        setFilteredChargerData(response.data.data.data || []); 

       
    } catch (error) {
        console.error("Error fetching ChargerData:", error);
    } finally {
        setLoading(false);
    }
};

useEffect(() => {
  fetchChargerrs();  // Fetch chargers based on the current page and search term
}, []);

  // Fetch charger list
  useEffect(() => {
    const fetchChargers = async () => {
      try {
        Swal.fire({
          title: 'Processing...',
          text: 'please wait...',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        const response = await axios.get(`${BaseURL}/chargers/?type=shift&station_id=${stationID}`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        // Assuming API returns an array of chargers, each with an IMEI number and name
        const formattedChargers = response.data.data.data.map(charger => ({
          value: charger._id,  // The unique identifier (IMEI)
          label: charger.imei_number,          // The label to display in the dropdown
        }));
        setChargers(formattedChargers);
        Swal.close();
      } catch (error) {
        console.error("Error fetching chargers:", error);
      }
    };

    fetchChargers();
  }, []);

  const handleChargersChange = (selectedOptions) => {
    // Store the selected IMEI numbers in state
    const selectedEmis = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setSelectedEmi(selectedEmis);
  };

  const AssignCharger = async () => {
    // Show loader before API call
    Swal.fire({
      title: 'Assigning Chargers...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    try {
      // Make the API request
      let response = await axios.put(
        `${BaseURL}/chargers/shift-charger-ids/${stationID}`,
        {
          charger_ids: selectedEmi,  // Send the selected IMEI numbers as "charger_ids" in the body
        },
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
            'Content-Type': 'application/json',
          },
        }
      );
  
      // Hide the loader
      Swal.close();
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response?.data?.message,
          showConfirmButton: false,
          timer: 1500,
        });
        // navigate(`/chargers`);
        fetchChargerrs();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to assign chargers. Status: ${response?.data?.statusCode}`,
        });
      }
    } catch (error) {
      // Hide the loader
      Swal.close();
      console.error("Error in AssignCharger:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };

  const fetchStatusListing = async () => {
    const apiEndpoint = `${BaseURL}/settings/charger/status`;

    setLoading(true);

    var url = apiEndpoint

    let res = await request({
      url: url,
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${uniqueToken}`,
      },
    });

    console.log("res", res);
   
    if (res && res.data) {
      setStatusListing(res.data);
      }

    return [];
  };

  useEffect(() => {
    fetchStatusListing();
  }, []);
  
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Assign Charger
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="chargers"
                              className="col-sm-2 control-label"
                            >
                              Select Chargers
                            </label>
                            <div className="col-sm-6">
                              <Select
                                isMulti
                                options={chargers}
                                onChange={handleChargersChange}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Select Chargers"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                      
                        <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={AssignCharger}
                              value="Submit"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                
              </div>
             
            </div>
          </div>

        </div>
        <div className="card-body" style={{ marginLeft: "-19px" }}>
                {loading ? (
                  <Loader /> 
                ) : (
                  <>
                   <div className="table-responsive">
  <table className="display dataTable" id="advance-1">
    <thead>
      <tr>
        <th>Sr. No</th>
        <th>Charger Name</th>
        <th>Installation Date</th>
        
        <th>IMEI Number</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      {filteredChargerData?.length === 0 ? (
        <tr>
          <td colSpan="8" className="text-center">No Data Available</td>
        </tr>
      ) : (
        filteredChargerData.map((charger, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{charger?.charger_name}</td>
            <td>{charger?.createdAt}</td>
        
            <td>{charger?.imei_number}</td>
            <td>
              <select
                onChange={(e) => handleStatusType(e, charger._id)}
                value={userStatuses[charger._id] || charger.status}
                className="custom-select"
                id="statusType"
                name="statusType"
              >
                {statusListing ? (
                  statusListing.map((statusObj, idx) => {
                    const statusKey = Object.keys(statusObj)[0];
                    const statusValue = statusObj[statusKey];
                    return (
                      <option key={idx} value={statusValue}>
                        {statusValue}
                      </option>
                    );
                  })
                ) : (
                  <option>Loading...</option>
                )}
              </select>
            </td>
            <td>
              <Link to={`/chargers/edit/${charger?._id}`} state={{ ChargerEditData: charger }}>
                <i className="fa fa-edit" title="Edit Charger"></i>
              </Link>
              &nbsp;&nbsp;
              <Link to={`/chargers/view/${charger?._id}`}>
                <i className="fa fa-eye" title="View Charger"></i>
              </Link>
            </td>
          </tr>
        ))
      )}
    </tbody>
  </table>
</div>


              
                  </>
                )}
              </div>
      </div>
    </>
  );
}

export default Assign;
